export default __webpack_public_path__ + "static/card-sub-iphone-5-9c18c03c70a8888139ce0716486997ca.svg";